import { useContext } from 'react';
import { PostContext } from '../../../../../context/PostContext';

const HashTags = () => {
  const { hashTags, isLocked } = useContext(PostContext);
  return (
    <div>
      <div
        className={`${
          isLocked && 'line-clamp-2'
        } text-[#009CE0] flex flex-wrap gap-1 my-2`}
      >
        {hashTags.map((item, _index) => (
          <span className="font-normal text-xs p-[4px_2px]" key={_index}>
            #{item.name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HashTags;
